import {
  List,
  ListItem,
  Typography,
  Grid,
  makeStyles
} from '@material-ui/core';
import { DSScreenStatusBoardCell, Order } from 'kiolyn-api';
import React, { FC } from 'react';

const useStyles = makeStyles(() => ({
  boardContainer: {
    flexGrow: 1
  },
  orderContainer: {
    flexGrow: 1
  },
  orderHeader: {
    textAlign: 'center',
    fontWeight: 'bold'
  },
  prepareList: {
    border: '1px solid',
    flex: 1
  },
  readyList: {
    borderWidth: '1px 1px 1px 0',
    borderStyle: 'solid',
    flex: 1
  }
}));

interface StatusBoardCellProps {
  cell: DSScreenStatusBoardCell;
  orders?: Order[];
}

const StatusBoardCell: FC<StatusBoardCellProps> = ({
  orders,
  cell
}: StatusBoardCellProps) => {
  const classes = useStyles();
  const defaultFontSize = 20;
  const headerFontSizeRatio = 1.5;
  const contentFontSize = cell.font_size ?? defaultFontSize;
  const headerFontSize = contentFontSize * headerFontSizeRatio;

  return (
    <Grid item container direction="column" className={classes.boardContainer}>
      <Grid
        item
        container
        className={classes.orderContainer}
        style={{
          height: cell.is_full_height ? '' : cell.height
        }}
      >
        <List key="preparing" className={classes.prepareList}>
          <Typography
            key="header"
            className={classes.orderHeader}
            style={{
              fontSize: headerFontSize + 'px'
            }}
          >
            Preparing (Kitchen)
          </Typography>
          {orders?.map(
            (order, index) =>
              order.instore_status === 'PREPARING' && (
                <ListItem key={index}>
                  <Typography
                    key="header"
                    style={{
                      fontSize: contentFontSize + 'px'
                    }}
                  >
                    Order #{order.order_no}
                  </Typography>
                </ListItem>
              )
          )}
        </List>
        <List key="ready" className={classes.readyList}>
          <Typography
            key="header"
            className={classes.orderHeader}
            style={{
              fontSize: headerFontSize + 'px'
            }}
          >
            Ready (Runner)
          </Typography>
          {orders?.map(
            (order, index) =>
              order.instore_status === 'READY' && (
                <ListItem key={index}>
                  <Typography
                    key="header"
                    style={{
                      fontSize: contentFontSize + 'px'
                    }}
                  >
                    Order #{order.order_no}
                  </Typography>
                </ListItem>
              )
          )}
        </List>
      </Grid>
    </Grid>
  );
};

export default StatusBoardCell;
